/** @fileoverview get_indexing_job_details の共通定数 */

/** ツール名（単一参照点） */
export const GET_INDEXING_JOB_DETAILS_NAME =
  "get_indexing_job_details" as const;

/** LLM へ提示する説明文 */
export const GET_INDEXING_JOB_DETAILS_DESC = `Retrieves recent Index Worker jobs for a specific Index Worker, including per-task crawl/index status and Google coverage results. Provide an indexWorkerId to inspect. Optionally specify a jobId to fetch a single job, tweak the number of jobs and tasks returned, or filter tasks by their crawl/index flags.`;
